import React from "react";

function TextError(props) {
  return <div className="text-pw-red">{props.children}</div>;
}

export default TextError;
